import { provideEffects } from '@ngrx/effects';

export { TellentSecureChangeService } from './tellent-secure-change.service';
import { TellentSecureChangeEffects } from './tellent-secure-change.effects';
export const tellentSecureChangeEffects = provideEffects(TellentSecureChangeEffects);

export { TellentSecureChangeModule } from './tellent-secure-change.module';
